<div class="names" *ngIf="validationMessage !== null">
  <ion-note class="validationMessage" color="danger" slot="start">
    <ion-icon aria-label="validation warning" name="warning"></ion-icon>
    <span>{{validationMessage}}</span>
  </ion-note>
</div>